import cloneDeep from 'lodash/cloneDeep';
import { Participant } from 'modules/events/basics/types/events.types';

// Insert || Update entries with most recent values
export const upsertParticipants = (prevState: Participant[] = [], newState: Participant[] = []): Participant[] => {
  const cloned = cloneDeep([...prevState, ...newState]);
  return [...new Map(cloned.map((item) => [item.id, item])).values()];
};
